import { ExternalLink, PenTool } from "lucide-react";

function miroEmbed(url) {
  const m = url.match(/\/app\/board\/([^/?#]+)/);
  if (m) return `https://miro.com/app/live-embed/${m[1]}/?embedMode=view_only_without_ui&autoplay=true`;
  if (/live-embed/.test(url)) return url;
  return null;
}

export default function MiroEmbed({ url }) {
  if (!url) {
    return (
      <div className="rounded-2xl border border-[#1E293B] bg-[#090D16] p-10 text-center text-slate-600 text-sm flex flex-col items-center gap-2">
        <PenTool className="w-6 h-6" /> No Miro board linked for this lesson.
      </div>
    );
  }
  const embed = miroEmbed(url);
  return (
    <div className="space-y-2" data-testid="miro-embed">
      {embed ? (
        <div className="relative rounded-2xl overflow-hidden border border-[#1E293B] bg-[#090D16]" style={{ height: 460 }}>
          <iframe src={embed} title="Miro board" allowFullScreen className="w-full h-full" />
        </div>
      ) : (
        <div className="rounded-2xl border border-[#1E293B] bg-[#090D16] p-8 text-center text-slate-500 text-sm">
          This Miro link can't be embedded — open it directly below.
        </div>
      )}
      <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm bg-[#111726] border border-[#1E293B] rounded-lg px-3 py-2 text-slate-200 hover:border-emerald-500/40 transition-colors w-fit" data-testid="open-miro-link">
        <ExternalLink className="w-4 h-4" /> Open in Miro
      </a>
    </div>
  );
}
